/*eslint sort-keys: ["error", "asc", {caseSensitive: false}]*/

import { ENResources } from './en';

export const es: Record<keyof ENResources, string> = {
  ban: 'Bloqueos',
  close: 'Cerca',
  contact: 'Contacto',
  contactDone: 'Gracias por tu mensaje.',
  contactEmail: 'Correo electrónico',
  contactMessage: 'Mensaje',
  copy: 'Copiar',
  create: 'Crear',
  defeat: 'FRACASO',
  donate: 'Donar',
  draftCreate: 'Comparte el borrador a tus amigos',
  draftDescription: 'Crea un borrador y compártelo con tus amigos.',
  draftList: 'Lista',
  draftLogs: 'Registros',
  draftSettingsCoin: 'Quien empieza',
  draftSettingsMode: '',
  draftSettingsTries: 'Número de intentos',
  draftShareText: 'Hola, intenta adivinar este borrador #BSDrafting',
  fanContentPolicy: 'Política de contenidos de fans',
  fanContentPolicyLink: 'http://supercell.com/en/fan-content-policy/es/',
  footer:
    'Este material no es oficial y no está respaldado por Supercell.\nPara obtener más información, consulte la {FanContentPolicy}',
  guessLast: 'Último',
  guessTwoLast: 'Dos últimos',
  homeDescription:
    'El sitio para perfeccionar tus habilidades de draft en Brawl Stars.\n\nCrea composiciones estratégicas y desafía a tus amigos a adivinar tus elecciones.\n¡Mejora tus estrategias con nuestra plataforma intuitiva y conviértete en un experto en draft!',
  homeTitle: 'Bienvenido a BS Drafting',
  listEmptyDescription: 'Vamos a crear tu primer borrador',
  listEmptyTitle: 'Aún no hay borrador',
  listTeamShareText: 'Hola, intenta adivinar este borrador #BSDrafting',
  logsEmptyDescription:
    'Comparte el sitio con tus amigos y pídeles un borrador',
  logsEmptyTitle: 'Aún no hay registros',
  pick: 'Pick',
  share: 'Compartir',
  submit: 'Entregar',
  validate: 'Entregar',
  victory: 'VICTORIA',
};
